
import {Typography, Spin, Tooltip} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {observer} from 'mobx-react';
import styles from './style.module.scss';
import {SingleQuestion} from './SingleQuestion';
import {useStore} from '@/store/root-store';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faCopy} from '@fortawesome/pro-regular-svg-icons';
import {useState} from 'react';
import {useTranslation} from 'next-i18next';
import {copyToClipboardWithHtmlAndText} from '@/utils/clipboard';
// import {NextImg} from '@/utils/nextImg';


export const QuestionsTab = observer(() => {
  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');
  const {t} = useTranslation('common');

  const {Title} = Typography;
  const antIcon = <LoadingOutlined style={{fontSize: 16, color: '#7f4ead', marginLeft: '10px'}} spin />;

  const [copySuccess, setCopySuccess] = useState(false);

  const questionsMsg = () => {
    if (currentPage?.content?.targetKeywords?.length > 0 || 5 > 2) {
      return 'No Questions found for current Target Keywords';
    } else {
      return 'Please add Target Keywords to view Questions';
    }
  };


  return <>
    <Title level={4} style={{marginRight: '10px', marginTop: '20px', height: 22, fontSize: 14, fontWeight: 500, textTransform: 'capitalize', display: 'flex'}}>
        Questions {currentPage?.isAnalyzing ? <Spin indicator={antIcon} style={{marginRight: '20px'}}/> :
        currentPage?.analytics?.questions?.length ? <span className={styles.totalQuestions}>{`${currentPage?.analytics?.questions?.filter(question => question?.usedCount > 0)?.length}/${currentPage?.analytics?.questions?.length}`}</span> : null}
      <Tooltip
        title={copySuccess ? <span><FontAwesomeIcon icon={faCheck} style={{color: '#2AC155'}}/>{` Copied to clipboard`}</span> : t('copy-to-clipboard')}
        placement='top'
        overlayClassName={styles.copyTooltip}
        onVisibleChange={visible => {
          if (!visible) {
            setTimeout(() => {
              setCopySuccess(false);
            }, 300);
          }
        }}>
        <div style={{cursor: 'pointer', color: '#34AEF3', marginLeft: 'auto'}}
          onClick={() => {
            let htmlString = '<p></p>';
            let string = '';
            currentPage?.analytics?.questions?.map(question => {
              htmlString += (`<p>${question.keyword}?</p>`);
              string += (`${question.keyword}?`);
            });
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const copiedText = doc.body.textContent;
            navigator.clipboard.writeText(copiedText);

            // Example usage:
            const htmlContent = htmlString;
            const plainTextContent = string;

            copyToClipboardWithHtmlAndText(htmlContent, plainTextContent);
            setCopySuccess(true);
          }}>
          <FontAwesomeIcon icon={faCopy} style={{marginRight: 5}}/> Copy all
        </div>
      </Tooltip>
    </Title>
    {currentPage?.analytics?.questions?.length ? <div className={styles.questionsContainer}>
      <div className={styles.questionsInnerContainer}>
        {currentPage?.analytics?.questions?.map((question, i) => {
          return <SingleQuestion question={question} i={i} key={i}/>;
        })}
      </div>
    </div> :
      <div className={styles.emptyDataBox}>
        {/* <div className={styles.emptyImg}><NextImg src='/img/icon/comments-question-check.svg' /></div> */}
        <span className={styles.emptyDataTitle}>{questionsMsg()}</span>
      </div>}
  </>;
});
